import { Link } from 'react-router-dom';
import { homeData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20Japanese%20art%20studio%20with%20warm%20golden%20sunlight%20streaming%20through%20large%20windows%2C%20delicate%20cherry%20blossom%20branches%20in%20soft%20focus%2C%20calligraphy%20brushes%20and%20paintings%20on%20walls%2C%20serene%20and%20inspirational%20atmosphere%2C%20cream%20and%20warm%20beige%20tones%2C%20soft%20natural%20light&width=1600&height=900&seq=sora-hero-bg&orientation=landscape"
          alt="苍井空"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-wide" style={{ fontFamily: 'var(--font-heading)' }}>
          {homeData.hero.title}
        </h1>
        <p className="mt-4 md:mt-6 text-lg md:text-2xl text-white/90 font-light tracking-wider">
          {homeData.hero.subtitle}
        </p>
        <p className="mt-6 md:mt-8 text-sm md:text-base text-white/70 max-w-2xl mx-auto leading-relaxed">
          {homeData.hero.description}
        </p>
        <Link
          to={homeData.hero.ctaLink}
          className="inline-block mt-8 md:mt-10 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {homeData.hero.ctaText}
        </Link>
      </div>
    </section>
  );
}